import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/css/pc-base.css'
import './assets/css/quill.snow.css'
import 'babel-polyfill';
import Es6Promise from 'es6-promise'
require('es6-promise').polyfill()
Es6Promise.polyfill()

import 'swiper/dist/css/swiper.css'
Vue.config.productionTip = false
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
Vue.prototype.$wow = wow

import 'aos/dist/aos.css'
import AOS from 'aos/dist/aos.js'
Vue.prototype.$AOS = AOS

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import imgPreloaderList from './assets/js/imgPreloaderList.js';
import { imgsPreloader } from './assets/js/imgPreloader.js';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

(async () => {
    await imgsPreloader(imgPreloaderList);
    //关闭加载弹框
    document.querySelector('.loading').style.display = 'none';
    new Vue({
        router,
        store,
        render: h => h(App),
        mounted () {
            document.dispatchEvent(new Event('render-event'))
        }
    }).$mount('#app')
})();

router.afterEach( ( to, from, next ) => {
    setTimeout(()=>{
        var _hmt = _hmt || [];
        (function() {
            //每次执行前，先移除上次插入的代码
            document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?1c63e08dc455118fae4ed5cd02c6a3bc";
            hm.id = "baidu_tj"
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();
    },0);
} );



router.beforeEach((to,from,next)=>{
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '百昌 拍卖平台'
    }
    next()
})
